import React, { Component } from 'react'
import Button from './Button'
// import Button from '@mui/material/Button'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import Dialog from '@mui/material/Dialog'
// import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import withTranslationWrapper from '../../HOC/HocTranslate'

class ConfirmDialoag extends Component {
  constructor (props) {
    super(props)
    this.handleCancel = this.handleCancel.bind(this)
    this.handleOk = this.handleOk.bind(this)
    this.handleReject = this.handleReject.bind(this)
    this.handleRefund = this.handleRefund.bind(this)

    this.state = {
      open: true
    }
  }

  handleCancel () {
    if (this.props.onCancel) {
      this.props.onCancel()
      this.setState({ open: false })
    }
  }

  handleOk () {
    if (this.props.onOk) {
      this.props.onOk()
      this.setState({ open: false })
    }
  }

  handleRefund(){
       if (this.props.onRefund) {
      this.props.onRefund()
      this.setState({ open: false })
    }
  }

    handleReject(){
       if (this.props.onReject) {
      this.props.onReject()
      this.setState({ open: false })
    }
  }

  render () {
    return (
      <Dialog
        disableBackdropClick
        disableEscapeKeyDown
        aria-labelledby='confirmation-dialog-title'
        open={this.state.open}
        maxWidth={this.props.maxWidth || 'sm'}
      >
        {this.props.title && (
          <DialogTitle id='confirmation-dialog-title'>
            {this.props.translate(this.props.title)}
          </DialogTitle>
        )}
        <DialogContent>{this.props.children}</DialogContent>
        <DialogActions>
          <Button onClick={this.handleCancel} variant='outlined'>
            {this.props.translate(this.props.CancelText || 'cancel')}
          </Button>
          {
            this.props.showThirdButton&&
            <Button onClick={this.handleRefund} variant='primary' disabled={this.props.disabled}>
            {this.props.translate(this.props.refundText ||  this.props.translate('ok'))}
          </Button>
          }
               {
            this.props.showRejectButton&&
            <Button onClick={this.handleReject} variant='danger' disabled={this.props.disabled}>
            {this.props.translate(this.props.rejectText ||  this.props.translate('reject'))}
          </Button>
          }
          <Button onClick={this.handleOk} color='primary' disabled={this.props.disabled}>
            {this.props.translate(this.props.OkText ||  this.props.translate('ok'))}
          </Button>
        </DialogActions>
      </Dialog>
    )
  }
}

export default withTranslationWrapper (ConfirmDialoag)
